// TODO: Extract from best_in_place gem when Docker is available
// jquery.purr is a notification plugin required by best_in_place
// Original source: best_in_place gem vendor/assets/javascripts/jquery.purr.js
//
// For now, provide a no-op stub so the code doesn't break
(function($) {
  $.fn.purr = function(options) {
    // Stub: purr shows brief notification messages for best_in_place
    // When the real file is available, replace this stub
    return this;
  };
})(jQuery);
